import React from 'react';
import Html from 'react-pdf-html';
import { Page, Text, View, Document, StyleSheet, Image, Font, Link } from '@react-pdf/renderer';
import Roboto from '../fonts/Roboto-Regular.ttf';
import RobotoItalic from '../fonts/Roboto-Italic.ttf';
import RobotoBold from '../fonts/Roboto-Bold.ttf';
import RobotoBoldItalic from '../fonts/Roboto-BoldItalic.ttf';

Font.register({
	family: 'Roboto',
	fonts: [
		{ src: Roboto, fontStyle: 'normal', fontWeight: 'normal' },
		{ src: RobotoItalic, fontStyle: 'italic', fontWeight: 'normal' },
		{ src: RobotoBold, fontStyle: 'normal', fontWeight: 'bold' },
		{ src: RobotoBoldItalic, fontStyle: 'italic', fontWeight: 'bold' },
	],
});

// Create styles
const styles = StyleSheet.create({
	page: {
		flexDirection: 'row',
	},
	title: {
		padding: '20px 30px',
		fontSize: 20,
		marginBottom: 10,
	},
	text: {
		fontSize: 12,
		padding: '0 30px',
		lineHeight: '2rem',
		fontFamily: 'Roboto',
		fontStyle: 'normal',
	},
	quote: {
		fontSize: 12,
		padding: '0 30px',
		lineHeight: '2rem',
		fontStyle: 'italic',
		fontFamily: 'Roboto',
	},
});

// Create Document Component
function SbtFullTextPdf({ text, title }) {
	const splitText = text.split(/(<[^>]+?>[\s\S]*?<\/[^>]+?>)/).filter(Boolean);

	const texts = splitText.map((block) => {
		const tagMatch = block.match(/^<([a-z]+)[^>]*>([\s\S]*)<\/\1>$/);
		if (tagMatch) {
			// If the block is an HTML tag with content
			const tagName = tagMatch[1];
			let type;
			let value = block;
			switch (tagName) {
				case 'blockquote':
					type = 'quote';
					value = block.replace(/<\/?blockquote[^>]*>/g, '');
					break;
				case 'p':
				case 'span':
					type = 'text';
					value = block.replace(/<\/?(span|p)[^>]*>/g, '');
					break;
				case 'b':
				case 'strong':
					type = 'bold';
					value = block.replace(/<\/?b[^>]*>/g, '');
					break;
				case 'i':
				case 'em':
					type = 'italic';
					value = block.replace(/<\/?i[^>]*>/g, '');
					break;
				case 'a':
					type = 'link';
					value = {
						url: block.match(/href="([^"]+)"/)[1],
						text: block.replace(/<\/?a[^>]*>/g, ''),
					};
					break;

				default:
					type = 'text';
					value = block.replace(/<\/?[a-z]+[^>]*>/g, '');
					break;
			}
			
			return { type, value };
		} else {
			// Plain text
			return { type: 'text', value: block };
		}
	});

	return (
		<Document>
			<Page size='A4' style={styles.page}>
				<View>
					<Text style={styles.title}>{title}</Text>
					<Text style={styles.text}>
						{texts.map((textBlock, index) => {
							if (textBlock.type === 'html') {
								return <Html key={index} html={textBlock.value} />;
							}
							if (textBlock.type === 'quote') {
								return (
									<Text key={index} style={styles.quote}>
										{textBlock.value}
									</Text>
								);
							}
							if (textBlock.type === 'bold') {
								return (
									<Text key={index} style={{ ...styles.text, fontWeight: 'bold' }}>
										{textBlock.value}
									</Text>
								);
							}
							if (textBlock.type === 'italic') {
								return (
									<Text key={index} style={{ ...styles.text, fontStyle: 'italic' }}>
										{textBlock.value}
									</Text>
								);
							}

							if (textBlock.type === 'link') {
								return (
									<Link key={index} src={textBlock.value.url}>
										{textBlock.value.text}
									</Link>
								);
							}
							
							return (textBlock.value);
						})}
					</Text>
				</View>
			</Page>
		</Document>
	);
}

export default SbtFullTextPdf;
